import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Row, Col } from 'antd';
import * as productClassService from 'redux/services/productClass';
import { GlobalError } from 'components';
import { handleErrors } from 'Utils/errorHandler';
import { useHistory, useParams } from 'react-router-dom';

export default () => {
  const [form] = Form.useForm();
  const [globalErrors, setGlobalErrors] = useState([]);
  const [productClass, setProductClass] = useState(null);
  const history = useHistory();
  const { classId } = useParams();

  useEffect(() => {
    (async () => {
      try {
        setProductClass(await productClassService.findById(classId));
      } catch (err) {
        handleErrors(err, history, form);
      }
    })();
  }, [classId, form, history]);

  const handleSubmit = values => {
    (async () => {
      try {
        const updated = await productClassService.update(classId, {
          name: values.name,
          description: values.description
        });
        history.push(`/catalog/productClass/view/${updated.id}`);
      } catch (err) {
        setGlobalErrors(handleErrors(err, history, form));
      }
    })();
  };

  return (
    <div>
      <h2 className="page-title">Edit Product Class</h2>
      {productClass && (
        <>
          <GlobalError errors={globalErrors} />
          <Form form={form} onFinish={handleSubmit} initialValues={productClass}>
            <Row gutter={24}>
              <Col md={8} sm={24}>
                <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Name is required.' }]}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={16} sm={24}>
                <Form.Item name="description" label="Description">
                  <Input.TextArea />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col sm={24}>
                <Button type="primary" htmlType="submit">Update</Button>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </div>
  );
};
